import { version } from '../../package.json';

export const APP_VERSION = version ?? '#.##.#';
